import {
  setBrowseBy,
  setBrowseByFacet,
  setSorts,
  setLoadMore,
  setPopstate,
  setFilters,
  applyFilter,
  applySort,
  clearFilters,
  setFirstQuery,
} from '@/context/recipeFilter/action-creators';

export default dispatch => ({
  setBrowseBy: payload => dispatch(setBrowseBy(payload)),
  setBrowseByFacet: payload => dispatch(setBrowseByFacet(payload)),
  setSorts: payload => dispatch(setSorts(payload)),
  setLoadMore: payload => dispatch(setLoadMore(payload)),
  setPopstate: payload => dispatch(setPopstate(payload)),
  setFilters: payload => dispatch(setFilters(payload)),
  applyFilter: payload => dispatch(applyFilter(payload)),
  applySort: payload => dispatch(applySort(payload)),
  clearFilters: () => dispatch(clearFilters()),
  setFirstQuery: payload => dispatch(setFirstQuery(payload)),
});
